import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { usePricing } from '../context/PricingContext';

const PricingCard = ({ plan, paymentNotice, onGetStarted }) => {
  const { selectPackage, tmSignUpType } = usePricing();

  const handleGetStarted = () => {
    selectPackage(plan.name, plan.price);
    console.log({
      tmSignUpType,
      packageTitle: plan.name,
      packageAmount: plan.price
    });
    onGetStarted();
  };

  return (
    <Card
      className={`relative p-6 rounded-xl border-2 hover:shadow-xl transition-all duration-300 flex flex-col ${
        plan.recommended
          ? 'border-teal-500 shadow-lg scale-105'
          : 'border-gray-200 hover:border-teal-300'
      }`}
    >
      {plan.recommended && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="bg-teal-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
            Recommended
          </span>
        </div>
      )}
      
      <div className="text-center mb-6">
        <h3 className="text-xl font-bold text-slate-900 mb-2">{plan.name}</h3>
        <div className="mb-1">
          <span className="text-3xl font-bold text-teal-600">{plan.price}</span>
        </div>
        <p className="text-sm text-gray-600">{plan.federal}</p>
      </div>

      <div className="space-y-3 mb-4 max-h-64 overflow-y-auto custom-scrollbar" style={{
        scrollbarWidth: 'thin',
        scrollbarColor: '#0d9488 #e5e7eb'
      }}>
        <style>{`
          .custom-scrollbar::-webkit-scrollbar {
            width: 3px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #e5e7eb;
            border-radius: 3px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #0d9488;
            border-radius: 3px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #0f766e;
          }
          .custom-scrollbar::-webkit-scrollbar-button {
            display: none;
          }
          .custom-scrollbar::-webkit-scrollbar-corner {
            display: none;
          }
        `}</style>
        {plan.features.map((feature, index) => (
          <div key={index} className="flex items-start gap-2">
            <Check className="h-5 w-5 text-teal-600 flex-shrink-0 mt-0.5" />
            <span className="text-sm text-gray-700">{feature}</span>
          </div>
        ))}
      </div>

      <div className="text-xs text-gray-500 mb-4 text-center italic">
        {plan.note}
      </div>

      {paymentNotice && (
        <div className="text-xs text-gray-600 mb-4 text-center bg-gray-50 p-2 rounded">
          {paymentNotice}
        </div>
      )}

      <Button
        onClick={handleGetStarted}
        className={`w-full py-3 mt-auto ${
          plan.recommended
            ? 'bg-teal-600 hover:bg-teal-700 text-white'
            : 'bg-white hover:bg-teal-50 text-teal-600 border-2 border-teal-600'
        }`}
      >
        Choose {plan.name} Plan →
      </Button>
    </Card>
  );
};

export default PricingCard;
